import { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ButtonGroup, Button } from 'reactstrap'
import api from '../../../../api'
import ha from './images/ha.png'
import fi from './images/fi.png'
import rh from './images/rh.png'
import ing from './images/ing.png'

const SKILLS_IMAGES = {
  'HA': ha.src,
  'FI': fi.src,
  'RH': rh.src,
  'IN': ing.src,
}

class SkillsTreeModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      universes: [],
      selectedUniverse: false
    }
  }x

  componentDidMount() {
    this.fetchUniverses()
  }

  fetchUniverses = async () => {
    await api.universes.getAll()
      .then((response)=> {
        if(response.data) {
          this.setState({universes: response.data})
          this.setState({selectedUniverse: response.data[0].short_code})
        }
      })
      .catch((error) => {
        console.error({error})
      })
  }

  render() {
    const { modal, toggle } = this.props
    const { universes, selectedUniverse} = this.state

    return (
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Arbre de compétences</ModalHeader>

        <ModalBody>
          <div className="d-flex justify-content-center mb-4">
            <ButtonGroup>
              { universes.map(universe => (
                <Button
                  key={universe.id}
                  color="secondary"
                  outline
                  onClick={() => this.setState({selectedUniverse: universe.short_code})}
                  active={selectedUniverse === universe.short_code}
                >
                  {universe.name}
                </Button>
              )) }
            </ButtonGroup>
          </div>

          <figure className="d-block w-100">
            <img className="d-block w-100" src={SKILLS_IMAGES[selectedUniverse]} alt={selectedUniverse} />
          </figure>
        </ModalBody>
      </Modal>
    )
  }
}

export default SkillsTreeModal